import { useState } from "react";
// import {  Paper } from "@deere/fuel-react"
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogContentText,
  Box,
  CircularProgress,
  Typography,
  Button,
} from "@mui/material";

const SubmitAs2 = ({ as2Verification, message, controlSubmit, update }) => {
  const [openModal, setOpenModal] = useState(false);
  const [openProgress, setOpenProgress] = useState(false);

  const handleClose = () => {
    setOpenModal(false);
    window.location.reload();
  };

  const handleClickOpen = () => {
    setOpenModal((current) => !current);
  };

  const handleOpenProgress = () => {
    setOpenProgress((current) => !current);
  };

  return (
    <div>
      <Button
        type="submit"
        variant="primary"
        disabled={!controlSubmit}
        onClick={() => {
          handleOpenProgress();
          window.setTimeout(handleClickOpen, 15200);
          window.setTimeout(handleOpenProgress, 15100);
        }}
      >
        Create New AS2 Relationship
      </Button>

      <Dialog open={openProgress}>
        <Box display="flex" alignItems="center" justifyContent="center">
          <Box px={1} width="100%" maxWidth={300}>
            <Box
              alignItems="center"
              display="flex"
              flexDirection="column"
              height={200}
              justifyContent="center"
              p={4}
            >
              <CircularProgress />
              <Typography
                gutterBottom
                style={{
                  marginTop: "1rem",
                }}
                variant="h3"
              >
                {update
                  ? "Updating As2 Partner. Wait a moment..."
                  : "Creating As2 Partner. Wait a moment..."}
              </Typography>
              <Typography variant="subtitle2">
                {"This will take a couple seconds"}
              </Typography>
            </Box>
          </Box>
        </Box>
      </Dialog>

      {as2Verification ? (
        <Dialog
          open={openModal}
          onClose={handleClose}
          aria-labelledby="alert-Modal-title"
          aria-describedby="alert-Modal-description"
        >
          <DialogTitle id="alert-Modal-title">Success ✔️</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-Modal-description">
              {message}
            </DialogContentText>
          </DialogContent>
        </Dialog>
      ) : (
        <Dialog
          open={openModal}
          onClose={handleClickOpen}
          aria-labelledby="alert-Modal-title"
          aria-describedby="alert-Modal-description"
        >
          <DialogTitle variant="h3" id="alert-Modal-title">Process Failed ❌</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-Modal-description">
              {message}
            </DialogContentText>
          </DialogContent>
        </Dialog>
      )}
    </div>
  );
};

export default SubmitAs2;
